import { useRkVivocyberExperiment } from '@libs/renegkit/experiments/RkVivocyberExperiment';
import { ARC_IDENTIFIERS } from '@dues/helpers/btg';
import { useEffect, useState } from 'react';

interface URIErrorsePixExperimentProps {
  // TODO: adjust types
  debt: any;
  paymentOption: any;
}

export const partnersWithPixInternal = [
  'btg',
  'cielo',
  'colombo',
  'credigy',
  'credsystem',
  'credz',
  'acordocerto',
  'liftcred',
  'tribanco',
  'uzecartoes',
  'via',
  'itapeva',
  'sky',
  'riachuelo',
  'nubank',
  'kroton',
  'c6bank',
  'bradesco',
  'bradescard',
  'ativossa',
  'omni',
  'hoepers',
  'neon',
  ...ARC_IDENTIFIERS,
]; // Partners who must show Pix without the need for testing.

export const partnersWithPixExternal = [
  'recovery',
  'itau',
  'carrefour',
  'tim',
  'portoseguro',
  'ipanema',
  'bancodobrasil',
  'claro',
  'semparar',
  'havan',
]; // Partners with Pix integration through external service.

export const partnersForTest = ['vivo']; // Partners requiring Pix testing.

export const shouldGetPixWithoutBillet = (partnerIdentifier: string) => {
  // Partners that can generate pix without billet code
  const partnersWithoutBillet = ['kroton', 'hoepers', 'btg', 'nubank', 'neon', ...ARC_IDENTIFIERS];

  return partnersWithoutBillet.includes(partnerIdentifier);
};

const usePixExperiment = ({ debt, paymentOption }: URIErrorsePixExperimentProps) => {
  const [flowWithPix, setFlowWithPix] = useState<boolean | undefined>(false);
  const [isPixExternal, setIsPixExternal] = useState<boolean>(false);

  const { partnerIdentifier, identifier } = debt?.partner || {};
  const { resultIsWithPixVivocyber } = useRkVivocyberExperiment(identifier);

  interface resultsPartnersForTestProps {
    [key: string]: boolean;
  }

  const resultsPartnersForTest: resultsPartnersForTestProps = {
    // add here the partner to be tested with result variable, example:
    // nubank: resultIsWithPixNubankCards
    vivo: resultIsWithPixVivocyber,
  };

  const handlePix = (): boolean | undefined => {
    const valorEntrada = paymentOption?.entryValue || paymentOption?.valorEntrada;

    // Vivo Cyber: Pix liberado a 100% (rollout), independente do teste A/B.
    // O teste `dx-pix-vivocyber` segue valendo apenas para o Vivo Global (systemSlug 'vivo').
    // Diferenciamos pelo systemSlug (`identifier`), já que o creditor de ambos é 'vivo'.
    const isVivocyberPix = partnerIdentifier === 'vivo' && identifier === 'vivocyber';

    const isPixInternal =
      (partnersWithPixInternal?.includes(partnerIdentifier) || isVivocyberPix) && (partnerIdentifier === 'nubank' || valorEntrada < 1000);
    const rennerHasPixMethod = partnerIdentifier === 'lojasrenner' && debt?.paymentMethods?.some((method: any) => method === 'PIX');
    const isPixExternal = partnersWithPixExternal?.includes(partnerIdentifier) || rennerHasPixMethod;

    setIsPixExternal(isPixExternal);

    if (isPixInternal || isPixExternal) return true;

    const isPartnerForTest = partnersForTest?.includes(partnerIdentifier);
    if (isPartnerForTest) return resultsPartnersForTest[partnerIdentifier];

    return false;
  };

  useEffect(() => {
    if (paymentOption) {
      setFlowWithPix(() => handlePix());
    }
  }, [paymentOption]);

  return {
    flowWithPix,
    isPixExternal,
  };
};

export default usePixExperiment;
